export const regionKontorPreset = {
  layerList: [
    {
      type: 'wms',
      url: 'gis/geoserver/wms',
      queryable: false,
      tiled: true,
      params: {
        LAYERS: 'metria:Kontorsplatser',
        FORMAT: 'image/png8',
        CQL_FILTER: "KONTOR_TYP='Vokontor'",
      },
    },
    {
      type: 'wms',
      url: 'gis/geoserver/wms',
      queryable: true,
      tiled: false,
      params: {
        LAYERS: 'metria:Kontorsplatser',
        FORMAT: 'image/png8',
        CQL_FILTER: "KONTOR_TYP='Regionkontor'",
      },
      featureProperties: {
        Kontorsplatser: {
          displayName: 'Regionkontor',
          propertyAliases: {
            TEXT: 'Namn',
            KONTOR_TYP: 'Typ',
          },
        },
      },
    },
  ],
};

export const voPreset = {
  layerList: [
    {
      type: 'wms',
      url: 'gis/geoserver/wms',
      queryable: true,
      tiled: false,
      params: {
        LAYERS: 'metria:SBO_extweb',
        FORMAT: 'image/png8',
      },
      featureProperties: {
        SBO_extweb: {
          displayName: 'Verksamhetsområde',
          propertyAliases: {
            SBONR: 'SBO',
            SBONAMN: 'SBO namn',
          },
        },
      },
    },
  ],
};

export const sboPreset = {
  layerList: [
    {
      type: 'wms',
      url: 'gis/geoserver/wms',
      queryable: true,
      tiled: false,
      params: {
        LAYERS: 'metria:DSBO_extweb',
        FORMAT: 'image/png8',
      },
      featureProperties: {
        SBO_extweb: {
          displayName: 'Skogsbruksområde',
          propertyAliases: {
            DSBONR: 'SBO',
            DSBONAMN: 'SBO namn',
          },
        },
      },
    },
  ],
};
